import { HeadCellsWithToggle } from '../../../tree-data-view';

export const headCells: HeadCellsWithToggle[] = [
  {
    Header: 'Field Name',
    id: 'fieldName',
    accessor: 'fieldName',
    minWidth: 80,
  },
  {
    Header: 'Hex Value',
    id: 'hexValue',
    accessor: 'hexValue',
  },
  {
    Header: 'Converted Value',
    id: 'convertedValue',
    accessor: 'convertedValue',
  },
  {
    Header: 'Display Value',
    id: 'displayValue',
    accessor: 'displayValue',
  },
];
